import { render } from "./BookingRecipientDetailsSection.vue?vue&type=template&id=16077c9c"
import script from "./BookingRecipientDetailsSection.vue?vue&type=script&lang=js"
export * from "./BookingRecipientDetailsSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__